"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSiteApiResponseSchema = exports.createSiteApiPayloadSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
exports.createSiteApiPayloadSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(80),
});
exports.createSiteApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
        type: (0, api_1.apiEntityTypeSchema)('sites'),
        attributes: zod_1.z.object({
            name: zod_1.z.string(),
            officeCount: zod_1.z.number().optional().default(0),
        }),
    }),
});
